import { json } from './api'
import type { FaqEntry } from '../../../../packages/api-client/src/help'
export type ManagedFaq = FaqEntry & { sort_order: number; is_published: boolean; updated_at: string }
export type FaqDraft = Omit<ManagedFaq, 'id' | 'updated_at'>
const base = '/v1/support/platform/faq/'
export const getFaqEntries = () => json<ManagedFaq[]>(base)
export const saveFaqEntry = (id: string | null, value: FaqDraft) => json<ManagedFaq>(id ? `${base}${encodeURIComponent(id)}/` : base, { method: id ? 'PATCH' : 'POST', body: JSON.stringify(value) })
